module.exports = __webpack_public_path__ + "img/ch13_02_触摸浪花.0446b7dc.jpg";